<script>
import { mapGetters } from 'vuex';
import i18n from './i18n';
import QuizPage from './containers/QuizPage.vue';
import EndPage from './containers/EndPage.vue';
import Wrapper from 'ne01-common/src/components/Wrapper';
import ErrorMessage from './components/ErrorMessage.vue';
import LoadIndicator from './components/LoadIndicator.vue';

export default {
  name: 'app',
  components: {
    Wrapper,
    ErrorMessage,
    LoadIndicator,
    QuizPage,
    EndPage,
  },
  mounted() {
    if(!window.apiUrl) {
      window.apiUrl = 'https://lasauge.bird-song.ch';
    }
    if(!window.cmsUrl) {
      window.cmsUrl = 'https://wp.ls.bird-song.ch';
    }
    if(!window.cmsSlug) {
      window.cmsSlug = 'station-4';
    }

    const visitorId = new URL(window.location.href).searchParams.get('visitor') || 1;
    const lang = new URL(window.location.href).searchParams.get('lang') || 'de';

    this.$store.dispatch('initApp', { visitorId, lang });
    this.$store.dispatch('loadCmsData', lang);

    i18n.locale = lang;
  },
  methods: {
    retryLoading() {
      if (this.lastAction === 'loadCmsData')
        this.loadCmsData();
      if (this.lastAction === 'sendStatistics')
        this.unloadStation();
    },
    unloadStation() {
      if (this.hasStarted) 
        this.$store.dispatch('sendStatistics', { ...this.statisticsTotals.normalized, visitor_id: this.visitorId, station_id: 4 });
      else 
        window.postMessage('end');
    },
  },
  computed: {
    ...mapGetters({
      lang: 'getLang',
      loading: 'getShowLoading',
      error: 'getDataLoadError',
      heading: 'getStationHeading',
      intro: 'getStationIntro',
      screenState: 'getStationScrrenState',
      introTrack: 'getStationIntroTrack',
      lastAction: 'getLastHttpAction',
      statisticsTotals: 'getStatisticsTotals',
      hasStarted: 'getHasStarted',
      visitorId: 'getVisitorId',
    })
  }
}
</script>

<template>
  <div id="app">
    <wrapper v-if="!loading && !error" v-bind:src="introTrack" v-bind:heading="heading" nr="4" v-on:exit="unloadStation">
      <div class="station-content">
        <quiz-page v-if="screenState === 'quiz'"></quiz-page>
        <end-page v-if="screenState === 'end'" v-on:unloadStation="unloadStation"></end-page>
      </div>
      <p slot="intro">{{intro}}</p>
    </wrapper>

    <div class="load-indicator" v-if="loading">
      <load-indicator></load-indicator>
    </div>

    <error-message v-bind:error="error" v-on:reloadData="retryLoading()"></error-message>

  </div>
</template>

<style lang="scss">
@import './assets/styles/fonts';
@import './assets/styles/variables';
@import './assets/styles/common';

#app {
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  font-family: var(--font-family-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--dark, black);
  background: var(--color-mainm, #CCC);
}
.station-content {
  position: absolute;
  box-sizing: border-box;
  top: 0; left: 0; width: 100%; height: 100%;
  min-height: 100%;
  // padding-top: calc(var(--bezel) * 1.75);
  padding-top: calc(var(--gutter) * 5);
  overflow-y: auto;
}
.load-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
